import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, of, forkJoin, empty } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { StorageManagerService, CompanyContactService } from '../../shared/services/index';
import { RefdataService } from '../services/refdata.service';



@Injectable()
export class CompanyResolverService implements Resolve<any> {

    companyRevisionId: string;

  constructor (private companyService: CompanyContactService, private storageManagerService: StorageManagerService,
        private refDataService: RefdataService) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
      const companyRevisionId = route.params.companyRevisionId;

        const retVal = forkJoin(
            this.companyService.getBusinessCategories(false),
            this.companyService.getCountries(),
            this.companyService.getContacts(),
            this.storageManagerService.read('businessOperationQualifiers') ? of(this.storageManagerService.read('businessOperationQualifiers')) : this.refDataService.GetAllBusinessOperationQualifier(),
            companyRevisionId ? this.companyService.getCompanyRevisionHistory(companyRevisionId) : of(null),
            companyRevisionId ? this.companyService.getBusinessOperationQualifierByCompany(companyRevisionId) : of(null),
            companyRevisionId ? this.companyService.getCompanyById(companyRevisionId) : of(null),
            companyRevisionId ? this.companyService.getNDCLabelerCodesByCompany(companyRevisionId) : of(null)
        )
        .pipe(catchError(err => of({ error: err })));

       return retVal;
  }
}
